import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import s from './Menu.module.scss';

export const VENUES = 'venues';
export const POI = 'poi';
export const ACCOUNTS = 'accounts';
export const API = 'api';
export const WAYFINDING = 'wayfinding';
export const COMMAND_LINE_TOOLS = 'Command Line Tools';
export const LAYERS = 'layers';
export const HELP = 'help';
export const SUPPORT = 'support';
export const IMPORT_EXPORT = 'Import/Export';
export const MOD_WIZARD = 'MapsOnDisplay Wizard';
export const VISITOR_INSIGHTS = 'Visitor Insights';

const menuItems = {
    venues: {
        label: 'Venues',
        icon: 'icon-venues',
    },
    poi: {
        label: 'POI',
        icon: 'icon-location',
    },
    accounts: {
        label: 'Accounts & Groups',
        icon: 'icon-accounts-n-groups',
    },
    api: {
        label: 'API',
        icon: 'icon-api',
    },
    [MOD_WIZARD]: {
        label: 'Digital Display',
        icon: 'icon-maplayers',
    },
    [VISITOR_INSIGHTS]: {
        label: 'Visitor Insights',
        icon: 'icon-newspaper',
    },
    wayfinding: {
        label: WAYFINDING,
        icon: 'icon-help',
    },
    layers: {
        label: 'Show Layer Warnings',
        icon: 'icon-help',
    },
    [COMMAND_LINE_TOOLS]: {
        label: COMMAND_LINE_TOOLS,
        icon: 'icon-help',
    },
    help: {
        label: 'Go To Playground',
        icon: 'icon-help',
    },
    support: {
        label: 'Support',
        icon: 'icon-supportheadphones',
    },
    [IMPORT_EXPORT]: {
        label: 'Data Exchange',
        icon: 'icon-import-export',
    },
};

class Menu extends PureComponent {
    static propTypes = {
        email: PropTypes.string,
        env: PropTypes.string,
        firstName: PropTypes.string,
        hasPeopleDashboardsPermission: PropTypes.bool.isRequired,
        hasMapsOnDisplayWritePermission: PropTypes.bool.isRequired,
        hasVenuesReadPermission: PropTypes.bool.isRequired,
        isSubmenuOpen: PropTypes.bool.isRequired,
        internal: PropTypes.bool,
        lastName: PropTypes.string,
        onChange: PropTypes.func,
        onSubmenuChange: PropTypes.func,
        onSubmenuClick: PropTypes.func.isRequired,
        selectedIcon: PropTypes.string,
        selectedSubmenu: PropTypes.string,
    };

    static defaultProps = {
        email: '',
        env: '',
        internal: false,
        firstName: '',
        lastName: '',
        onChange: () => {},
        onSubmenuChange: () => {},
        selectedIcon: 'poi',
        selectedSubmenu: null,
    };

    selectSubmenu = selectedSubmenu => {
        this.props.onSubmenuChange(selectedSubmenu);
    };

    renderMenuItem(itemId, bottom) {
        const selected = itemId === this.props.selectedIcon;
        const menuItem = menuItems[itemId];
        const classes = [s.menuItem, { [s.bottom]: bottom }];

        if (selected) classes.push(s.selected);
        return (
            <div className={classNames(classes)} onClick={() => this.props.onChange(itemId)}>
                <div className={classNames(s.icon, menuItem.icon)} />
                <div className={s.label}>{menuItem.label}</div>
                {itemId === IMPORT_EXPORT ? <div className={s.comingSoonBanner}>Coming Soon</div> : <div />}
            </div>
        );
    }

    render() {
        const { firstName, lastName, email, selectedSubmenu, env, isSubmenuOpen, onSubmenuClick, internal, hasMapsOnDisplayWritePermission, hasVenuesReadPermission, hasPeopleDashboardsPermission } =
            this.props;

        return (
            <div className={s.menusWrapper}>
                <div className={s.menu}>
                    <div className={classNames(s.submenuToggle, { [s.isOpen]: isSubmenuOpen })} onClick={onSubmenuClick} data-cy={isSubmenuOpen ? 'mainMenuClose' : 'mainMenuOpen'}>
                        <div data-testid='hamburgerMenu' className={classNames(s.icon, isSubmenuOpen ? 'icon-close' : 'icon-hamburger-menu')}/>
                    </div>
                    {hasVenuesReadPermission && this.renderMenuItem(VENUES)}
                    {hasMapsOnDisplayWritePermission && this.renderMenuItem(MOD_WIZARD)}
                    {hasPeopleDashboardsPermission && this.renderMenuItem(VISITOR_INSIGHTS)}
                    {/* Hiding Import/Export tab but leaving code, since we might want to use it later */}
                    {/* {this.renderMenuItem(IMPORT_EXPORT)} */}
                    <div className={s.spacer} />
                    {env === 'develop' && internal ? this.renderMenuItem(COMMAND_LINE_TOOLS, false) : null}
                    {env === 'develop' && internal ? this.renderMenuItem(WAYFINDING, false) : null}
                    {/* { env === 'develop' && internal ? this.renderMenuItem(LAYERS, false) : null } */}
                    {env === 'develop' && internal ? this.renderMenuItem(HELP, false) : null}
                    {this.renderMenuItem(SUPPORT, true)}
                </div>
                <div className={classNames(s.submenu, { [s.expanded]: isSubmenuOpen })}>
                    <div className={s.profileInfo}>
                        <div className={s.avatar} />
                        <div className={s.userName}>{`${firstName} ${lastName}`}</div>
                        <div className={s.userEmail}>{email}</div>
                    </div>
                    <div className={s.submenuItems}>
                        <div className={classNames(s.submenuItem, { [s.selected]: selectedSubmenu === 'profile' })} onClick={() => this.selectSubmenu('profile')} data-cy='editProfileBtn'>
                            <span className={classNames(s.icon, 'icon-profile')} />
                            <span>Edit Profile</span>
                        </div>
                        <div className={classNames(s.submenuItem, { [s.selected]: selectedSubmenu === 'password' })} onClick={() => this.selectSubmenu('password')} data-cy='changePasswordBtn'>
                            <span className={classNames(s.icon, 'icon-lock')} />
                            <span>Change Password</span>
                        </div>
                        <div className={classNames(s.submenuItem, { [s.selected]: selectedSubmenu === 'logout' })} onClick={() => this.selectSubmenu('logout')} data-cy='logOutBtn'>
                            <span className={classNames(s.icon, 'icon-log-out')} />
                            <span>Log Out</span>
                        </div>
                    </div>
                    <div className={s.version}>Version {import.meta.env.VITE_REACT_APP_VERSION}</div>
                </div>
            </div>
        );
    }
}

export default Menu;
